<template>
  <div class="mediaList" v-if="renderComponent">
    <sideBar :isChange="isChange" />

    <div class="content-body-container col-md-8">
      <!--            media header-->
      <div class="media-list-header-container">
        <span style="display: inline-block; vertical-align: middle"><i class="fa fa-folder-open-o fa-2x sidebar-logo" aria-hidden="true"></i></span>

        <div style="display: inline-block; vertical-align: middle">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item v-for="(obj_Folder, i) of arrobj_FolderPath" :key="obj_Folder.GalID"
              ><span style="font-weight: bold; cursor: pointer" @click="backSpecificDirectory(obj_Folder, i)">{{ obj_Folder.GalFolder }}</span>
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>

        <!--                <label style="display: inline-block!important;">Folder name 02/02/2018</label>-->
        <!--                <a class="upload-item" style="color: #007bff; font-weight: unset; margin-left: 10px; cursor: pointer; vertical-align: middle;">Add Media</a>-->

        <div style="float: right; margin-bottom: 20px">
          <span class="" id="action-container">
            <!--                v-show="arrobj_Files.length > 0"-->
            <el-button-group class="gallery-select">
              <el-button id="btn_SelectAll" type="primary" icon="el-icon-arrow-left" :class="{ 'd-none': selectall === true }"
                >{{ lang('Select All') }}
              </el-button>
              <el-button id="btn_UnselectAll" type="primary" :class="{ 'd-none': arrobj_SelectedItem.length === 0 }"
                >{{ lang('Unselect All') }} <i class="el-icon-arrow-right el-icon-right"></i
              ></el-button>
            </el-button-group>
            <el-button-group class="gallery-action__item">
              <el-button type="primary" icon="el-icon-download" class="download-item" v-if="arrobj_SelectedItem.length > 0">{{ lang('Download') }} </el-button>
              <el-button type="primary" icon="el-icon-view" v-if="arrobj_SelectedItem.length > 0" @click="showViewModal">{{ lang('View') }} </el-button>
              <el-button type="primary" icon="el-icon-rank" @click="showMoveModal" v-if="arrobj_SelectedItem.length > 0">{{ lang('Move To') }} </el-button>
              <!--                            <el-button type="primary" icon="el-icon-picture" @click="showPortfolioModal"-->
              <!--                                       v-if="arrobj_SelectedItem.length > 0">{{lang("Portfolio")}}-->
              <!--                            </el-button>-->
              <el-button type="primary" icon="el-icon-edit" @click="showUpdateModal" v-if="arrobj_SelectedItem.length > 0">{{ lang('Moment') }} </el-button>
              <el-button
                class="delete-action1"
                type="primary"
                icon="el-icon-delete"
                @click="showRemoveModal"
                v-if="obj_ContextTarget != null || arrobj_SelectedItem.length > 0"
                >{{ lang('Delete') }}
              </el-button>
            </el-button-group>
          </span>

          <el-popover placement="bottom" width="100" trigger="click" class="createNewMedia">
            <button @click="showCreateModal" class="gallery-createFolder btn btn-link" :title="lang('New') + '' + lang('Folder')" style="display: block">
              <!--                        <i class="fa fa-plus"></i>-->
              <span class="ml-2">{{ lang('New Folder') }}</span>
            </button>

            <button @click="dropdownUploadFile" class="gallery-createFolder btn btn-link">
              <span class="ml-2">{{ lang('Upload') }}</span>
            </button>

            <el-button slot="reference" class="createDropdown">
              <i class="fa fa-plus"></i> <span class="ml-2">{{ lang('Create') }}</span>
            </el-button>
          </el-popover>

          <el-popover style="display: inline-block" placement="bottom" width="100" trigger="click" class="feed-box__dropdown" v-if="isBigScreenWidth">
            <!--                    <button class="btn btn-link">Download Folder</button>-->
            <button @click="downloadItem" class="btn btn-link">{{ lang('Download Selected') }}</button>
            <el-button slot="reference" style="padding: 6px 12px"><i class="fa fa-ellipsis-v" aria-hidden="true"></i></el-button>
          </el-popover>

          <el-button class="download-selected" @click="downloadItem" type="primary" v-if="!isBigScreenWidth">{{ lang('Download Selected') }}</el-button>
        </div>

        <!--                                <span style="float: right; padding: 8px 20px; vertical-align: middle; cursor: pointer;"><i class="fa fa-ellipsis-v" aria-hidden="true"></i></span>-->
        <!--                <button @click="showCreateModal" class="gallery-createFolder btn btn-primary"-->
        <!--                        :title="lang('New')+''+lang('Folder')" style="padding: 5px 10px; display: inline-block; float: right;"><i-->
        <!--                        class="fa fa-plus"></i>-->
        <!--                    <span class="ml-2">{{lang("New")}}{{lang("Folder")}}</span>-->
        <!--                </button>-->

        <!--                <a class="upload-item" style="color: #007bff; font-weight: unset; margin: 5px; cursor: pointer; float: right;">{{lang("Add")}}{{lang("Media")}}</a>-->
      </div>

      <!--            media folder list-->
      <div class="media-file-folder-list-container div_ItemContainer">
        <div class="">
          <div class="single-folder-container" v-for="obj_Folder of arrobj_Folders" :key="obj_Folder.GalID" :data-type="obj_Folder.GalType">
            <button class="btn btn-media-folder" :id="obj_Folder.GalID" @click="changeDirectory(obj_Folder)">
              <i class="material-icons"> perm_media </i>
              <span style="margin-left: 10px">{{ obj_Folder.GalFolder }}</span>
              <i class="fa fa-angle-right" aria-hidden="true" style="float: right; margin: 5px 0px"></i>
            </button>
          </div>
        </div>
      </div>

      <!--            media action bar-->
      <!--            <div class="" id="action-container" style="text-align: right; padding: 10px;">-->
      <!--&lt;!&ndash;                v-show="arrobj_Files.length > 0"&ndash;&gt;-->
      <!--                <el-button-group>-->
      <!--                    <el-button id="btn_SelectAll" type="primary" icon="el-icon-arrow-left"-->
      <!--                               :class="{'d-none':selectall===true}">{{lang("Select")}}{{lang("All")}}-->
      <!--                    </el-button>-->
      <!--                    <el-button id="btn_UnselectAll" type="primary"-->
      <!--                               :class="{'d-none':arrobj_SelectedItem.length === 0}">{{lang("Unselect")}}{{lang("All")}}-->
      <!--                        <i class="el-icon-arrow-right el-icon-right"></i></el-button>-->
      <!--                </el-button-group>-->
      <!--                <el-button-group class="gallery-action__item">-->
      <!--                    <el-button type="primary" icon="el-icon-download" class="download-item"-->
      <!--                               v-if="arrobj_SelectedItem.length > 0">{{lang("Download")}}-->
      <!--                    </el-button>-->
      <!--                    <el-button type="primary" icon="el-icon-view" v-if="arrobj_SelectedItem.length > 0"-->
      <!--                               @click="showViewModal">{{lang("View")}}-->
      <!--                    </el-button>-->
      <!--                    <el-button type="primary" icon="el-icon-rank" @click="showMoveModal"-->
      <!--                               v-if="arrobj_SelectedItem.length > 0">{{lang("Move")}}-->
      <!--                    </el-button>-->
      <!--                    <el-button type="primary" icon="el-icon-picture" @click="showPortfolioModal"-->
      <!--                               v-if="arrobj_SelectedItem.length > 0">{{lang("Post as learning moment")}}-->
      <!--                    </el-button>-->
      <!--                    <el-button type="primary" icon="el-icon-edit" @click="showUpdateModal"-->
      <!--                               v-if="arrobj_SelectedItem.length > 0">{{lang("Post as Updates")}}-->
      <!--                    </el-button>-->
      <!--                    <el-button class="delete-action" type="primary" icon="el-icon-delete" @click="showRemoveModal"-->
      <!--                               v-if="obj_ContextTarget != null || arrobj_SelectedItem.length > 0">{{lang("Remove")}}-->
      <!--                    </el-button>-->
      <!--                </el-button-group>-->
      <!--            </div>-->

      <div class="empty-list_image" v-if="arrobj_Files.length <= 0">
        <strong>{{ empty_message }}</strong>
        <img src="../assets/notfound.png" />
      </div>

      <!--            media list-->
      <div class="bg-white div_ItemContainer">
        <div class="single-media col-md-3" v-for="obj_File of arrobj_Files" :key="obj_File.GalID">
          <!--                    <div class="media-file-list">-->
          <!--                        <img class="single-media-img" v-if="isImage(obj_File)" :src="getLowSource(obj_File)" :alt="obj_File.GalFileName"-->
          <!--                             draggable="false"/>-->
          <!--                    </div>-->
          <div class="media-file">
            <label :for="obj_File.GalID" class="media-file-image-container">
              <img class="media-file-image" v-if="isImage(obj_File)" :src="obj_File.FilePath" :alt="obj_File.GalFileName" draggable="false" />

              <LazyVideo class="media-file-image" v-if="isVideo(obj_File)" style="max-width: 100%" :src="obj_File.FilePath" />

              <!--                            <video class="media-file-image" v-if="isVideo(obj_File)" controls style="max-width: 100%;">-->
              <!--                                <source :src="`data:`+obj_File.GalFileType+`;base64, ${obj_File.GalFile}`" :type="obj_File.GalFileType" :alt="obj_File.GalFileName">-->
              <!--                            </video>-->

              <audio class="media-file-image" v-if="isAudio(obj_File)" controls style="max-width: 100%">
                <!--                                <source :src="`data:`+obj_File.GalFileType+`;base64, ${obj_File.GalFile}`" :type="obj_File.GalFileType" :alt="obj_File.GalFileName">-->
                <source :src="obj_File.FilePath" :alt="obj_File.GalFileName" />
              </audio>

              <pdf
                class="media-file-image"
                v-if="!isImage(obj_File) && !isVideo(obj_File) && !isAudio(obj_File) && obj_File.GalFileExt.toLowerCase() === '.pdf'"
                :src="obj_File.FilePath"
                style="max-width: 100%; overflow: auto"
              ></pdf>
            </label>

            <input
              class="limited"
              type="checkbox"
              hidden="hidden"
              :id="obj_File.GalID"
              :value="obj_File"
              v-model="arrobj_SelectedItem"
              :disabled="isNull(arrobj_SelectedItem.find(x => x.GalID === obj_File.GalID)) && arrobj_SelectedItem.length >= int_SelectLimit"
            />
            <label :for="obj_File.GalID"></label>
          </div>

          <!--                    <div class="media-file-more-action">-->
          <!--                        <span style="margin-right: 10px;"><i class="fa fa-thumbs-o-up fa-2x sidebar-logo" aria-hidden="true"></i> 10 likes</span>-->
          <!--                        <span><i class="fa fa-comments-o fa-2x sidebar-logo" aria-hidden="true"></i> 5 comments</span>-->
          <!--                    </div>-->
        </div>

        <!--                <div class=" gallery-album">-->
        <!--                    <div class="" v-for="obj_File of arrobj_Files" :key="obj_File.GalID">-->
        <!--                        <label :for="obj_File.GalID" class="gallery-album__image">-->
        <!--                            <img v-if="isImage(obj_File)" :src="getLowSource(obj_File)" :alt="obj_File.GalFileName"-->
        <!--                                 draggable="false"/>-->
        <!--                        </label>-->
        <!--                        <input class="limited" type="checkbox" :id="obj_File.GalID" :value="obj_File"-->
        <!--                               v-model="arrobj_SelectedItem"-->
        <!--                               :disabled="isNull(arrobj_SelectedItem.find(x=>x.GalID === obj_File.GalID)) && arrobj_SelectedItem.length >= int_SelectLimit"/>-->
        <!--                        <label :for="obj_File.GalID"></label>-->
        <!--                    </div>-->
        <!--                </div>-->
      </div>

      <!--             @change="uploadFiles($event.target.files)"-->
      <input type="file" id="fileUpload" multiple hidden="hidden" />

      <div id="div_ContextMenu" class="border border-secondary bg-white rounded-right rounded-bottom text-left">
        <ul id="ul_ContextMenuOptions">
          <li class="li_MenuOption" @click="showCreateModal">
            <i class="fa fa-folder-open-o"></i><span class="menu-text">{{ lang('New Folder') }}</span>
          </li>
          <li class="li_MenuOption" @click="showRenameModal" v-if="obj_ContextTarget != null">
            <i class="fa fa-pencil-square-o"></i><span class="menu-text">{{ lang('Rename') }}</span>
          </li>
          <li class="li_MenuOption download-item" v-if="arrobj_SelectedItem.length > 0">
            <i class="fa fa-download"></i>
            <span class="menu-text">{{ lang('Download') }}</span>
          </li>
          <li class="li_MenuOption upload-item">
            <i class="fa fa-upload"></i>
            <span class="menu-text">{{ lang('Upload') }}</span>
          </li>
          <li class="li_MenuOption" @click="showViewModal" v-if="arrobj_SelectedItem.length > 0">
            <i class="fa fa-eye"></i><span class="menu-text">{{ lang('View') }}</span>
          </li>
          <li class="li_MenuOption" @click="showMoveModal" v-if="arrobj_SelectedItem.length > 0">
            <i class="fa fa-arrows"></i><span class="menu-text">{{ lang('Move To') }}</span>
          </li>
          <li class="li_MenuOption" @click="showRemoveModal" v-if="obj_ContextTarget != null || arrobj_SelectedItem.length > 0">
            <i class="fa fa-trash-o"></i><span class="menu-text">{{ lang('Delete') }}</span>
          </li>
          <!--                    <li class="li_MenuOption" @click="showPortfolioModal" v-if="arrobj_SelectedItem.length > 0">-->
          <!--                        <i class="fa fa-eye"></i>-->
          <!--                        <span class="menu-text">{{lang("Portfolio")}}</span>-->
          <!--                    </li>-->
          <li class="li_MenuOption" @click="showUpdateModal" v-if="arrobj_SelectedItem.length > 0">
            <i class="fa fa-eye"></i>
            <span class="menu-text">{{ lang('Moment') }}</span>
          </li>
        </ul>
      </div>
    </div>

    <!--        media modal-->
    <b-modal id="modal_ViewItem" :title="lang('View')" ref="modal_ViewItem" centered ok-only :ok-title="lang('Close')">
      <b-carousel
        id="carousel1"
        style="text-shadow: 1px 1px 2px #333"
        controls
        indicators
        background="#ababab"
        :interval="4000"
        v-model="slide"
        @sliding-start="onSlideStart"
        @sliding-end="onSlideEnd"
      >
        <b-carousel-slide v-for="obj_Item of filteredSelectedItem" :key="obj_Item.FileID">
          <img slot="img" class="d-block img-fluid w-100" v-if="isImage(obj_Item)" :src="obj_Item.FilePath" :alt="obj_Item.GalFileName" />

          <LazyVideo slot="img" class="d-block img-fluid w-100" v-if="isVideo(obj_Item)" :src="obj_Item.FilePath" />

          <span>{{ obj_Item.GalFileName }}</span>
        </b-carousel-slide>
      </b-carousel>
    </b-modal>

    <b-modal
      id="modal_NewFolder"
      :title="lang('New') + '' + lang('Folder')"
      ref="modal_NewFolder"
      centered
      :ok-title="lang('Create')"
      @ok="createFolder"
      @keyup.enter.native="createFolder"
      :cancel-title="lang('Cancel')"
    >
      <div class="form-group">
        <input
          type="text"
          maxlength="25"
          ref="tb_FolderName"
          class="form-control"
          id="tb_FolderName"
          v-model="str_NewFolderName"
          :placeholder="lang('Please enter folder name')"
          autocomplete="off"
          autofocus
        />
      </div>
    </b-modal>

    <b-modal
      id="modal_RenameFolder"
      :title="lang('Rename') + '' + lang('Folder')"
      ref="modal_RenameFolder"
      centered
      :ok-title="lang('Rename')"
      @ok="renameFolder"
      @keyup.enter.native="renameFolder"
    >
      <div class="form-group">
        <input
          type="text"
          maxlength="25"
          ref="tb_RenameFolder"
          class="form-control"
          id="tb_RenameFolder"
          v-model="str_NewFolderName"
          :placeholder="lang('New') + '' + lang('Folder') + '' + lang('Name')"
          autocomplete="off"
          autofocus
        />
      </div>
    </b-modal>

    <b-modal
      id="modal_RemoveItem"
      :title="lang('Remove')"
      ref="modal_RemoveItem"
      centered
      :ok-title="lang('Confirm')"
      @ok="removeItems"
      :cancel-title="lang('Cancel')"
    >
      <div class="form-group">
        <div v-if="obj_ContextTarget != null && arrobj_SelectedItem.length > 0">
          {{ lang('Are you sure you want to delete the folder and the selected image(s)') }}
        </div>
        <div v-else-if="obj_ContextTarget == null && arrobj_SelectedItem.length > 0">
          {{ lang('Please confirm you want to delete the selected media') }}
        </div>
        <div v-else-if="obj_ContextTarget != null && arrobj_SelectedItem.length === 0">
          {{ lang('Are you sure you want to remove the folder') }}
        </div>
      </div>
    </b-modal>

    <b-modal id="modal_MoveItem" :title="lang('Move To')" ref="modal_MoveItem" centered @ok="MoveItems" :ok-title="lang('OK')" :cancel-title="lang('Cancel')">
      <div class="row modal_MoveItem-buttonGroup">
        <div class="col-lg-4">
          <el-button type="primary" id="btn_MoveModalPrevious" @click="MoveModalGoBack">
            <i class="el-icon-house"></i>
            {{ lang('Back') }}
          </el-button>

          <div v-for="obj_MoveModalFolder of arrobj_MoveModalFolders" :key="obj_MoveModalFolder.GalID" :data-type="obj_MoveModalFolder.GalType">
            <el-button type="primary" @click="MoveModalChangeDirectory(obj_MoveModalFolder)">
              <i class="el-icon-folder"></i>
              {{ obj_MoveModalFolder.GalFolder }}
              <i class="el-icon-arrow-right"></i>
            </el-button>
          </div>
        </div>
        <div class="col-lg-8">
          <div class="modal_MoveItem-slider">
            <b-carousel id="carousel2" style="text-shadow: 1px 1px 2px #333" controls indicators background="#ababab" :interval="0">
              <b-carousel-slide v-for="obj_Item of arrobj_SelectedItem" :key="obj_Item.FileID">
                <img slot="img" :src="obj_Item.FilePath" :alt="obj_Item.GalFileName" />
              </b-carousel-slide>
            </b-carousel>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal id="modal_PostComponents" hide-footer size="lg" @hidden="hideComponentModal" :title="str_PostComponentTitle" ref="modal_PostComponent">
      <component @result="displayResult" :is="obj_SelectedComponent" :images="arrobj_SelectedItem" @notifChange="notifChange"></component>
    </b-modal>

    <div id="div_DropZone" class="hideDropZone">
      <h1>{{ lang('Drop file(s) here to upload') }}</h1>
    </div>
  </div>
</template>

<script>
'use strict'
import DataSource from '../data/datasource'

import sideBar from '../components/Sidebar'
// import portfolio from "../components/Post_Portfolio_Component";
import portfolio from '../components/postPortfolioComponent'
import updates from '../components/Post_Updates_Component.vue'
import { lang } from '../locale/index'

import $ from 'jquery'

import pdf from 'vue-pdf'

import Vue from 'vue'
import VueLazyLoadVideo from 'vue-lazyload-video'
Vue.use(VueLazyLoadVideo)

export default {
  name: 'NewMedia',
  components: {
    sideBar,
    portfolio,
    updates,
    pdf,
  },
  data() {
    return {
      empty_message: lang('Media') + lang('Not Found'),
      arrobj_Folders: [],
      arrobj_Files: [],
      arrobj_FolderPath: [{ GalFolder: lang('Gallery'), GalID: 'PRIMARY', GalType: 'Folder' }],
      arrobj_SelectedItem: [],
      arrobj_MoveModalFolders: [],
      arrobj_MoveModalFolderPath: [],
      arrstr_Whitelist: [],
      int_StartRowNo: 1,
      int_EndRowNo: 10,
      obj_ContextTarget: {},
      obj_SelectedComponent: '',
      obj_ComponentProperties: {},
      slide: 0,
      sliding: null,
      str_NewFolderName: '',
      str_PostComponentTitle: '',
      str_Result: '',
      systemmsgError: false,
      int_SelectLimit: 30,
      selectall: false,
      renderComponent: true,
      isClickedRemove: false,

      isChange: false,
      isLoad: false,
      defaultAAC: 'audio/aac',
      isBigScreenWidth: true,
    }
  },
  methods: {
    lang,
    loadWhitelist() {
      this.arrstr_Whitelist = []

      DataSource.shared.getWhitelist().then(result => {
        if (result.Table) {
          this.arrstr_Whitelist = result.Table
        }
        // this.arrstr_Whitelist = result.Table;
      })
    },
    isWhitelist(file) {
      let temparrstr = file.name.split('.')
      let str_Ext = ('.' + temparrstr[temparrstr.length - 1]).toUpperCase()
      let isWhitelisted = this.arrstr_Whitelist.findIndex(x => x.type.toUpperCase() === str_Ext) !== -1
      let isValidFile = file.size > 0

      return isWhitelisted && isValidFile
    },
    initFolder(obj_Folder) {
      this.arrobj_Files = []
      this.arrobj_Folders = []
      this.arrobj_SelectedItem = []
      this.int_StartRowNo = 1
      this.int_EndRowNo = 10

      this.getFolders(obj_Folder).then(result => {
        this.arrobj_Folders = result
      })
      this.loadFiles(obj_Folder)

      // if (this.arrobj_Folders.length <= 0) {
      //     this.arrobj_Folders = obj_Folder.GalFolder;
      // }
    },
    changeDirectory(obj_Folder) {
      this.arrobj_FolderPath.push(obj_Folder)

      this.initFolder(obj_Folder)
    },
    backSpecificDirectory(obj_Folder, i) {
      let checkPop = i + 1
      let obj_PreviousFolder = this.arrobj_FolderPath[i]
      this.initFolder(obj_PreviousFolder)
      // if (this.arrobj_FolderPath.length !== checkPop) {
      //     this.arrobj_FolderPath.pop();
      // }
      let folderLength = this.arrobj_FolderPath.length

      for (folderLength; folderLength > checkPop; folderLength--) {
        if (this.arrobj_FolderPath.length !== checkPop) {
          this.arrobj_FolderPath.pop()
        }
      }
    },
    getFolders(obj_Folder) {
      // this.showLoading();
      return new Promise((resolve, reject) => {
        DataSource.shared.getFolders(obj_Folder.GalID).then(result => {
          let temp = []
          if (result.code != 2 && result.code != 99) temp = result.Table

          resolve(temp)
        })
      })
    },
    loadFiles(obj_Folder) {
      /*RECURSIVE FUNCTION ONLY ON FIRST ENTRY*/
      this.getFiles(obj_Folder)
        .then(result => {
          this.arrobj_Files.push.apply(this.arrobj_Files, result)
          // if (!this.isScrollable() && result != null)
          //     this.loadFiles(obj_Folder);
        })
        .then(() => {
          this.hideLoading()
        })
    },
    getFiles(obj_Folder) {
      this.showLoading()
      return new Promise((resolve, reject) => {
        DataSource.shared.getFiles(obj_Folder.GalID, this.int_StartRowNo, this.int_EndRowNo).then(result => {
          let arr_Result

          if (result.code != 2 && result.code != 99) {
            arr_Result = result.Table

            this.int_StartRowNo = this.int_EndRowNo + 1
            this.int_EndRowNo = this.int_EndRowNo + 10
          }

          // console.log(arr_Result);

          resolve(arr_Result)
        })
      })
    },
    goBack() {
      if (this.arrobj_FolderPath.length >= 1) this.arrobj_FolderPath.pop()

      let obj_PreviousFolder = this.arrobj_FolderPath[this.arrobj_FolderPath.length - 1]

      this.initFolder(obj_PreviousFolder)
    },
    isImage(obj_File) {
      let ext = String(obj_File.GalFileExt).toUpperCase()
      let isImage = false

      switch (ext) {
        case '.PNG':
        case '.JPG':
        case '.BMP':
        case '.GIF':
        case '.JPEG':
          isImage = true
          break
        default:
          isImage = false
          break
      }

      return isImage
    },
    getLowSource(file) {
      if (this.isImage(file)) return 'data:' + file.GalFileType + ';base64,' + file.GalFileLow
      else return ''
    },
    getMidSource(file) {
      if (this.isImage(file)) return 'data:' + file.GalFileType + ';base64,' + file.GalFileMedium
      else return ''
    },
    showPortfolioModal() {
      if (this.arrobj_SelectedItem.length > 0) {
        this.$router.push({
          name: 'Post Portfolio',
          params: {
            images: this.arrobj_SelectedItem,
            displayMode: 'Portfolio',
          },
        })
      } else {
        this.$notify.error({
          title: 'Error',
          message: 'Please select at least 1 file!',
        })
      }

      // this.obj_SelectedComponent = portfolio;
      // this.str_PostComponentTitle = lang("Learning Moment");
      // this.showComponentModal();
    },
    showUpdateModal() {
      this.isChange = false
      this.obj_SelectedComponent = updates
      this.str_PostComponentTitle = lang('Moment')
      this.showComponentModal()
    },
    displayResult(value) {
      switch (value) {
        case 'TRUE':
          this.$notify({
            title: lang('Success'),
            message: lang('Successfully Posted'),
            type: 'success',
          })
          // this.str_Result = "Successfully posted!";
          break
        case 'FALSE':
          this.$notify.error({
            title: lang('Error'),
            message: lang('Whoops. Something went wrong. Please check your fields and try again.'),
          })
          // this.str_Result = "Whoops. Something went wrong. Please check your fields and try again.";
          break
      }

      this.hideComponentModal()
    },
    showComponentModal() {
      this.obj_ComponentProperties = { images: this.arrobj_SelectedItem }
      this.$refs.modal_PostComponent.show()
    },
    hideComponentModal() {
      this.obj_SelectedComponent = false
      this.$refs.modal_PostComponent.hide()
    },
    isNull(obj) {
      return obj === null || obj === undefined || obj === 'undefined' || obj.length === 0 || obj === ''
    },

    /*#region Download Item Functions*/
    downloadItem() {
      let arr_Promises = []
      this.showLoading()

      for (let obj_SelectedItem of this.arrobj_SelectedItem) {
        let downloadPromise = new Promise((resolve, reject) => {
          DataSource.shared.downloadFile(obj_SelectedItem.GalID).then(result => {
            let file = result.Table[0]
            let a = document.createElement('a')
            let contentType = this.getContentType(file)
            let b64Data = file.GalFile
            let blob = this.b64toBlob(b64Data, contentType)

            a.href = URL.createObjectURL(blob)
            a.download = (file.GalFileName + file.GalFileExt).toString()
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            a.remove()
            resolve(result)
          })
        })

        arr_Promises.push(downloadPromise)
      }

      Promise.all(arr_Promises).then(result => {
        this.hideLoading()
      })
    },
    getContentType(e) {
      let contentType = ''

      switch (e.GalFileExt.toUpperCase()) {
        case '.PDF':
          contentType += 'application/octet-stream'
          break
        default:
          contentType += e.GalFileType
          break
      }

      return contentType
    },
    b64toBlob(b64Data, contentType, sliceSize) {
      //Credit to Jeremy Banks @ stackoverflow
      contentType = contentType || ''
      sliceSize = sliceSize || 512

      let byteCharacters = atob(b64Data)
      let byteArrays = []

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        let slice = byteCharacters.slice(offset, offset + sliceSize)

        let byteNumbers = new Array(slice.length)
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i)
        }

        let byteArray = new Uint8Array(byteNumbers)

        byteArrays.push(byteArray)
      }

      return new Blob(byteArrays, { type: contentType })
    },
    /*#endregion*/

    /*#region Create Folder Functions*/
    showCreateModal() {
      $('.createDropdown').trigger('click')
      // this.click();
      this.$refs.modal_NewFolder.show()
    },
    hideCreateModal() {
      this.$refs.modal_NewFolder.hide()
    },
    createFolder() {
      if (this.str_NewFolderName == null) return

      let obj_CurrentFolder = this.arrobj_FolderPath[this.arrobj_FolderPath.length - 1],
        str_NewFolderName = this.str_NewFolderName

      this.showLoading()
      DataSource.shared.createFolder(obj_CurrentFolder.GalID, str_NewFolderName).then(result => {
        this.initFolder(obj_CurrentFolder)
        this.str_NewFolderName = ''
        this.hideLoading()
        this.hideCreateModal()
      })
    },
    /*#endregion*/

    /*#region Rename Item Functions*/
    showRenameModal() {
      this.$refs.modal_RenameFolder.show()
    },
    hideRenameModal() {
      this.$refs.modal_RenameFolder.hide()
    },
    renameFolder() {
      if (this.str_NewFolderName == null) return

      let obj_CurrentFolder = this.arrobj_FolderPath[this.arrobj_FolderPath.length - 1],
        obj_TargetFolder = this.obj_ContextTarget,
        str_NewFolderName = this.str_NewFolderName

      DataSource.shared
        .renameFile(obj_TargetFolder.id, str_NewFolderName)
        .then(result => {
          this.showLoading()
        })
        .then(() => {
          this.initFolder(obj_CurrentFolder)
          this.str_NewFolderName = ''
          this.obj_ContextTarget = {}
          this.hideLoading()
        })
    },
    /*#endregion*/

    /*#region Upload Item Functions*/
    /*#region Drop Zone Functions*/
    showDropZone() {
      $('#div_DropZone').css({
        visibility: 'visible',
        opacity: '1',
      })
    },
    hideDropZone() {
      $('#div_DropZone').css({
        visibility: 'hidden',
        opacity: 0,
      })
    },
    /*#endregion*/

    async uploadFiles(filesUploaded) {
      if (filesUploaded.length > 0) {
        this.$vs.loading()
        await this.sleep(500)

        try {
          let obj_CurrentFolder = this.arrobj_FolderPath[this.arrobj_FolderPath.length - 1]

          let arrobj_AcceptedFiles = []

          for (let file of filesUploaded) {
            if (this.isWhitelist(file)) arrobj_AcceptedFiles.push(file)
          }

          const saveResponse = await DataSource.shared.saveFile(arrobj_AcceptedFiles, obj_CurrentFolder.GalID).then(result => {
            this.$vs.loading.close()
            this.initFolder(obj_CurrentFolder)
          })
        } catch (e) {
          console.log(e)
        }
      } else {
        this.hideLoading()
      }
    },
    /*#endregion*/

    /*#region View Item Functions*/
    showViewModal() {
      this.$refs.modal_ViewItem.show()
    },
    hideViewModal() {
      this.$refs.modal_ViewItem.show()
    },
    /*#endregion*/

    /*#region Move Item Functions*/
    showMoveModal() {
      this.$refs.modal_MoveItem.show()
      this.arrobj_MoveModalFolderPath = []
      this.arrobj_MoveModalFolderPath.push.apply(this.arrobj_MoveModalFolderPath, this.arrobj_FolderPath)
      let obj_CurrentFolder = this.arrobj_MoveModalFolderPath[this.arrobj_MoveModalFolderPath.length - 1]

      this.MoveModalInitFolder(obj_CurrentFolder)
    },
    hideMoveModal() {
      this.$refs.modal_MoveItem.hide()
    },
    MoveModalGoBack() {
      if (this.arrobj_MoveModalFolderPath.length >= 1) this.arrobj_MoveModalFolderPath.pop()
      if (this.arrobj_MoveModalFolderPath.length > 0) {
        let obj_PreviousFolder = this.arrobj_MoveModalFolderPath[this.arrobj_MoveModalFolderPath.length - 1]
        this.MoveModalInitFolder(obj_PreviousFolder)
      }
    },
    MoveModalChangeDirectory(obj_Folder) {
      this.arrobj_MoveModalFolderPath.push(obj_Folder)
      this.MoveModalInitFolder(obj_Folder)
    },
    MoveModalInitFolder(obj_Folder) {
      this.arrobj_MoveModalFolders = []

      this.getFolders(obj_Folder).then(result => {
        this.arrobj_MoveModalFolders = result
        this.hideLoading()
      })
    },

    MoveItems() {
      this.showLoading()

      let arr_Promises = []
      let obj_TargetFolder = this.arrobj_MoveModalFolderPath[this.arrobj_MoveModalFolderPath.length - 1]

      for (let obj_ItemToMove of this.arrobj_SelectedItem) arr_Promises.push(DataSource.shared.moveFile(obj_ItemToMove.GalID, obj_TargetFolder.GalID))

      Promise.all(arr_Promises).then(() => {
        this.hideLoading()
        this.initFolder(this.arrobj_FolderPath[this.arrobj_FolderPath.length - 1])
      })
    },
    /*#endregion*/

    /*#region Remove Item Functions*/
    showRemoveModal() {
      this.$refs.modal_RemoveItem.show()
    },
    hideRemoveModal() {
      this.$refs.modal_RemoveItem.hide()
    },
    removeItems() {
      this.showLoading()

      let arrstr_IDToRemove = []
      let arr_Promises = []

      if (this.arrobj_SelectedItem.length === 0) {
        arrstr_IDToRemove.push(this.arrobj_FolderPath[this.arrobj_FolderPath.length - 1].GalID)
        let lastIndex = this.arrobj_FolderPath.length - 1
        this.arrobj_FolderPath.splice(lastIndex, 1)
      }

      if (this.obj_ContextTarget != null) arrstr_IDToRemove.push(this.obj_ContextTarget.id)

      for (let obj_SelectedItem of this.arrobj_SelectedItem) arrstr_IDToRemove.push(obj_SelectedItem.GalID)

      for (let str_IDToRemove of arrstr_IDToRemove) {
        arr_Promises.push(DataSource.shared.removeFile(str_IDToRemove))
      }

      Promise.all(arr_Promises).then(() => {
        this.isClickedRemove = false
        this.hideLoading()

        if (this.arrobj_FolderPath.length > 0) {
          this.initFolder(this.arrobj_FolderPath[this.arrobj_FolderPath.length - 1])
        } else {
          this.arrobj_FolderPath = [{ GalFolder: lang('Gallery'), GalID: 'PRIMARY', GalType: 'Folder' }]
          this.initFolder(this.arrobj_FolderPath[0])
        }
        // this.initFolder(this.arrobj_FolderPath[this.arrobj_FolderPath.length - 1]);
      })

      /*if (i === itemsToRemove.length)
                    this.initFolder(this.filteredFolderPath[this.filteredFolderPath - 1]);*/
    },
    /*#endregion*/

    /*#region Custom Context Menu Functions*/
    showContextMenu(e) {
      e.preventDefault()
      this.obj_ContextTarget = null
      let div_ContextMenu = $('#div_ContextMenu')

      div_ContextMenu.css('display', 'block')

      // console.log(e.clientY);
      // console.log(e);
      // console.log(e.screenY);
      // console.log(div_ContextMenu.outerHeight());

      if (e.clientX + div_ContextMenu.outerWidth() >= $(document).innerWidth()) div_ContextMenu.css('left', e.clientX - div_ContextMenu.outerWidth() + 'px')
      else div_ContextMenu.css('left', e.clientX + 'px')

      if (e.screenY + div_ContextMenu.outerHeight() >= $(document).innerHeight()) div_ContextMenu.css('top', e.clientY - div_ContextMenu.outerHeight() + 'px')
      else if (e.screenY < div_ContextMenu.outerHeight()) div_ContextMenu.css('top', 0 + 'px')
      else div_ContextMenu.css('top', e.clientY + 'px')

      if ($(e.target).closest('div').data('type') != null && $(e.target).closest('div').data('type').toUpperCase() === 'FOLDER')
        this.obj_ContextTarget = e.target.closest('button')
    },
    hideContextMenu() {
      $('#div_ContextMenu').css('display', 'none')
    },
    /*#endregion*/

    /*#region Loader Functions*/
    showLoading() {
      this.$vs.loading()
    },
    hideLoading() {
      this.$vs.loading.close()
    },
    /*#endregion*/

    /*#region Carousel Slider*/
    onSlideStart(slide) {
      this.sliding = true
    },
    onSlideEnd(slide) {
      this.sliding = false
    },
    /*endregion*/

    /*#region Scroll Loader Functions*/
    getScrollPercent() {
      //Credits to Phil Ricketts @ stackoverflow
      let height = document.documentElement,
        body = document.body,
        scrollTop = 'scrollTop',
        scrollHeight = 'scrollHeight'

      return ((height[scrollTop] || body[scrollTop]) / ((height[scrollHeight] || body[scrollHeight]) - height.clientHeight)) * 100
    },

    isScrollable() {
      return $(document).height() > $(window).height()
    },

    debounce(func, wait, immediate) {
      // Returns a function, that, as long as it continues to be invoked, will not
      // be triggered. The function will be called after it stops being called for
      // N milliseconds. If `immediate` is passed, trigger the function on the
      // leading edge, instead of the trailing.
      let timeout, result
      let self = this

      let later = function (context, args) {
        timeout = null
        if (args) result = func.apply(context, args)
      }

      let debounced = self.restArguments(function (args) {
        if (timeout) clearTimeout(timeout)
        if (immediate) {
          let callNow = !timeout
          timeout = setTimeout(later, wait)
          if (callNow) result = func.apply(this, args)
        } else {
          timeout = self.delay(later, wait, this, args)
        }

        return result
      })

      debounced.cancel = function () {
        clearTimeout(timeout)
        timeout = null
      }

      return debounced
    },
    delay(func, wait, ...args) {
      // Lodash Delay
      /**
       * Invokes `func` after `wait` milliseconds. Any additional arguments are
       * provided to `func` when it's invoked.
       *
       * @since 0.1.0
       * @category Function
       * @param {Function} func The function to delay.
       * @param {number} wait The number of milliseconds to delay invocation.
       * @param {...*} [args] The arguments to invoke `func` with.
       * @returns {number} Returns the timer id.
       * @example
       *
       * delay(text => console.log(text), 1000, 'later')
       * // => Logs 'later' after one second.
       */
      if (typeof func != 'function') {
        throw new TypeError('Expected a function')
      }
      return setTimeout(func, +wait || 0, ...args)
    },
    restArguments(func, startIndex) {
      // Some functions take a variable number of arguments, or a few expected
      // arguments at the beginning and then a variable number of values to operate
      // on. This helper accumulates all remaining arguments past the function?s
      // argument length (or an explicit `startIndex`), into an array that becomes
      // the last argument. Similar to ES6?s "rest parameter".
      startIndex = startIndex == null ? func.length - 1 : +startIndex
      return function () {
        let length = Math.max(arguments.length - startIndex, 0),
          rest = Array(length),
          index = 0
        for (; index < length; index++) {
          rest[index] = arguments[index + startIndex]
        }
        switch (startIndex) {
          case 0:
            return func.call(this, rest)
          case 1:
            return func.call(this, arguments[0], rest)
          case 2:
            return func.call(this, arguments[0], arguments[1], rest)
        }
        let args = Array(startIndex + 1)
        for (index = 0; index < startIndex; index++) {
          args[index] = arguments[index]
        }
        args[startIndex] = rest
        return func.apply(this, args)
      }
    },
    /*#endregion*/

    /*#region Custom check functions*/
    isCheck(id) {
      if (this.isNull(id)) return

      let checkbox = $('#' + id)
      if (checkbox.prop('checked')) {
        checkbox.closest('div').addClass('check')
        checkbox.closest('div').removeClass('uncheck')
      } else {
        checkbox.closest('div').addClass('uncheck')
        checkbox.closest('div').removeClass('check')
      }
    },
    /*#endregion*/

    forceRerender() {
      // Remove my-component from the DOM
      this.renderComponent = false

      this.$nextTick(() => {
        // Add the component back in
        this.renderComponent = true
      })
    },

    scrollToTop() {
      window.scrollTo(0, 0)
    },

    notifChange() {
      this.isChange = true
    },

    dropdownUploadFile() {
      $('#fileUpload').click()
      // this.showLoading();
    },

    isVideo(obj_File) {
      let ext = String(obj_File.GalFileExt).toUpperCase()
      let isVideo = false

      switch (ext) {
        case '.MP4':
          isVideo = true
          break
        default:
          isVideo = false
          break
      }

      return isVideo
    },

    isAudio(obj_File) {
      let ext = String(obj_File.GalFileExt).toUpperCase()
      let isAudio = false

      switch (ext) {
        case '.MP3':
        case '.AAC':
        case '.WAV':
        case '.M4A':
          isAudio = true
          break
        default:
          isAudio = false
          break
      }

      return isAudio
    },

    sleep(milliseconds) {
      return new Promise(resolve => setTimeout(resolve, milliseconds))
    },

    isMobile() {
      // if (screen.width <= 760) {
      if (window.innerWidth <= 1025) {
        this.isBigScreenWidth = false
        // return true;
      } else {
        this.isBigScreenWidth = true
        // return false;
      }
    },
  },
  created() {
    window.addEventListener('resize', this.isMobile)
  },
  destroyed() {
    window.removeEventListener('resize', this.isMobile)
    $(window).unbind('scroll')
    $(window).unbind('resize')
  },
  mounted() {
    const self = this
    // self.forceRerender();
    self.initFolder(self.arrobj_FolderPath[0])
    self.loadWhitelist()

    self.scrollToTop()
    self.isMobile()

    window.history.scrollRestoration = 'manual'

    $(document).ready(function () {
      $('.content-body-container').css('min-height', window.outerHeight)
      $('.media-file-folder-list-container').appendTo('.sidebar-action-container .action-body')
    })

    /*#region Menu Functions*/
    $(document)
      .off('click', '.create-item')
      .on('click', '.create-item', () => {
        self.showCreateModal()
      })
    $(document)
      .off('click', '.rename-item')
      .on('click', '.rename-item', () => {
        self.showRenameModal()
      })
    $(document)
      .off('click', '.download-item')
      .on('click', '.download-item', () => {
        self.downloadItem()
      })
    $(document)
      .off('click', '.upload-item')
      .on('click', '.upload-item', () => {
        $('#fileUpload').click()
      })
    $(document)
      .off('click', '.view-item')
      .on('click', '.view-item', () => {
        self.showViewModal()
      })
    $(document)
      .off('click', '.move-item')
      .on('click', '.move-item', () => {
        self.showMoveModal()
      })
    $(document)
      .off('click', '.remove-item')
      .on('click', '.remove-item', () => {
        self.showRemoveModal()
      })
    /*#endregion*/

    /*#region Custom Context Functions*/
    $(document)
      .off('contextmenu', '.div_ItemContainer')
      .on('contextmenu', '.div_ItemContainer', e => {
        self.showContextMenu(e)
      })

    $(document)
      .off('contextmenu', '#div_ContextMenu')
      .on('contextmenu', '#div_ContextMenu', e => {
        e.preventDefault()
      })

    $(window).click(() => {
      self.hideContextMenu()
    })
    /*#endregion*/

    $('#btn_Previous').click(() => {
      if (this.arrobj_FolderPath.length > 1) self.goBack()
    })

    $('#btn_MoveModalPrevious').click(() => {
      if (this.arrobj_MoveModalFolderPath.length > 1) self.MoveModalGoBack()
    })

    /*#region Upload Functions*/
    $(window).on('dragenter', () => {
      self.showDropZone()
    })

    $(window).on('dragover', e => {
      e.preventDefault()
      self.showDropZone()
    })

    $(window).on('dragleave', e => {
      self.hideDropZone()
    })

    $('#div_DropZone').on('drop', e => {
      e.preventDefault()
      self.showLoading()
      self.hideDropZone()

      self.uploadFiles(e.originalEvent.dataTransfer.files)
    })

    $('#fileUpload').on('change', function (e) {
      e.preventDefault()
      self.$vs.loading()
      self.uploadFiles(e.target.files)
    })
    /*#endregion*/

    /*#region Scroll/Resize Loader Functions*/
    $(window).scroll(
      self.debounce(() => {
        // $(window).scroll(function() {
        if (self.getScrollPercent() >= 60) {
          // let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight;
          // const listElm = document.querySelector('#main-content');
          // if(listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
          let obj_CurrentFolder = self.arrobj_FolderPath[self.arrobj_FolderPath.length - 1]
          self
            .getFiles(obj_CurrentFolder)
            .then(result => {
              self.arrobj_Files.push.apply(self.arrobj_Files, result)
            })
            .then(() => {
              self.hideLoading()
            })
        }
        // });
      }, 250),
    )
    // $(window).resize(self.debounce(() => {
    //     let obj_CurrentFolder = this.arrobj_FolderPath[this.arrobj_FolderPath.length - 1];
    //     if (!self.isScrollable)
    //         self.getFiles(obj_CurrentFolder).then((result) => {
    //             this.arrobj_Files.push.apply(this.arrobj_Files, result);
    //         }).then(() => {
    //             this.hideLoading();
    //         });
    // }, 250));
    /*#endregion*/

    /*#region Select/Unselect All Functions*/
    $('#btn_SelectAll').click(() => {
      this.selectall = true
      let cb_All = $("input[type='checkbox']")

      cb_All.each(function () {
        $(this).prop('checked', true)

        self.isCheck($(this).attr('id'))
        $(this)[0].dispatchEvent(new Event('change'))
      })
    })

    $('#btn_UnselectAll').click(() => {
      this.selectall = false
      let cb_All = $("input[type='checkbox']")

      cb_All.each(function () {
        if ($(this).prop('checked')) $(this).prop('checked', false)

        self.isCheck($(this).attr('id'))
        $(this)[0].dispatchEvent(new Event('change'))
      })
    })
    /*#endregion*/

    $(document)
      .off('click', '.delete-action')
      .on('click', '.delete-action', e => {
        e.preventDefault()
        self.isClickedRemove = true
      })
  },
  updated() {
    const self = this

    $("input[type='checkbox']").each(function () {
      self.isCheck($(this).attr('id'))
    })
  },
  computed: {
    filteredSelectedItem: function () {
      return this.arrobj_SelectedItem
      // return this.arrobj_SelectedItem.filter(x => this.isImage(x));
    },
  },
}
</script>

<style scoped>
.content-body-container {
  display: inline-block;
  padding: 20px;
  background: white;
}

.media-list-header-container {
  text-align: left;
  margin-bottom: 20px;
  font-size: 12px;
}

.media-list-header-container > span {
  margin-right: 10px;
}

.div_ItemContainer {
  text-align: left;
  margin-top: 20px;
}

.single-media {
  display: inline-block;
  min-height: 200px;
  border-radius: 8px;
  vertical-align: middle;
  margin-bottom: 20px;
}

.media-file {
  background: #eee;
  min-height: inherit;
  border-radius: inherit;
  border: 1px solid #d8dbde87;
  position: relative;
}

.media-file-image-container {
  min-height: inherit;
  border-radius: inherit;
  margin: 0px;
  max-height: 200px;
  text-align: center;
}

.media-file-image {
  min-height: inherit;
  /*border-radius: inherit;*/
  border-radius: 20px;
  cursor: pointer;
  max-height: inherit;
  padding: 10px;
  object-fit: contain;
}

.media-file input[type='checkbox'] + label {
  width: 20px;
  height: 20px;
  position: absolute;
  margin: auto;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  text-indent: -999px;
  overflow: hidden;
  cursor: pointer;
  border: 2px solid #3c3956;
  background: transparent !important;
  border-radius: 50% !important;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  top: 20px;
  left: 20px;
}

.media-file input[type='checkbox'] + label:before {
  content: '';
  width: 12px;
  height: 12px;
  top: 0;
  left: 0;
  bottom: -60px;
  right: 0;
  position: absolute;
  margin: auto;
  background: #3c3956;
  border-radius: 50%;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}

.media-file input[type='checkbox']:checked + label:before {
  bottom: 0;
}

.btn-media-folder {
  text-align: left;
  width: 100%;
}

.media-file-more-action {
  padding: 5px 0px;
}

.media-file-more-action > span > i {
  color: cornflowerblue;
}

.single-folder-container {
  border-bottom: 1px solid lightgrey;
}

/*#region Custom context menu*/
#div_ContextMenu {
  width: auto;
  -webkit-box-shadow: 0 4px 5px 3px rgba(0, 0, 0, 0.2);
  box-shadow: 0 0px 10px -1px rgba(0, 0, 0, 0.2);
  position: fixed;
  display: none;
  border-color: #ccc0 !important;
  border-radius: 4px !important;
}

#div_ContextMenu #ul_ContextMenuOptions {
  padding: 0;
  list-style: none;
  margin: 0px;
}

#div_ContextMenu .li_MenuOption {
  font-weight: 500;
  font-size: 12px;
  padding: 10px 20px 10px 17px;
  cursor: pointer;
  border-bottom: 1px solid #eee;
}

#div_ContextMenu .li_MenuOption .menu-text {
  margin-left: 10px;
}

#div_ContextMenu .li_MenuOption:hover {
  background: rgb(237, 240, 244);
}

#div_ContextMenu:before {
  content: '';
  background: transparent;
  width: 20px;
  height: 20px;
  width: 0;
  height: 0;
  border-top: 10px solid white;
  border-left: 10px solid transparent;
  position: absolute;
  left: -22px;
  top: 13px;
  /* box-shadow: 0 0px 11px -5px rgba(0, 0, 0, 0.9); */
  border-top: 8px solid transparent;
  border-right: 11px solid white;
  border-bottom: 8px solid transparent;
}

#div_ContextMenu .li_MenuOption:last-child {
  border: 0px;
}
/*#end region Custom context menu*/

#div_DropZone {
  visibility: hidden;
  opacity: 0;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 9999999999;
  /*background-color: rgba(0, 0, 0, 0.5);*/
  background: rgba(0, 0, 0, 0.45);
  transition:
    visibility 175ms,
    opacity 175ms;
  display: table;
  text-shadow: 1px 1px 2px #000;
  color: #fff;
  font:
    bold 42px Oswald,
    DejaVu Sans,
    Tahoma,
    sans-serif;
}

#div_DropZone h1 {
  display: table-cell;
  text-align: center;
  vertical-align: middle;
}

.check {
  -webkit-transform: scale(0.8);
  -moz-transform: scale(0.8);
  -ms-transform: scale(0.8);
  -o-transform: scale(0.8);
  transform: scale(0.8);
  opacity: 0.5;
  background-color: lightgray;
  transition: all 0.3s;
  /*border: 2px solid black;*/
}

.uncheck {
  -webkit-transform: scale(1);
  -moz-transform: scale(1);
  -ms-transform: scale(1);
  -o-transform: scale(1);
  transform: scale(1);
  opacity: 1;
  background-color: revert;
  transition: all 0.3s;
}

.gallery-createFolder,
.btn-media-folder {
  font-size: 12px;
}

#btn_SelectAll {
  border-radius: 4px 0px 0px 4px;
  padding: 5px 10px;
  /*width: 100%;*/
  margin: 0;
}

#btn_UnselectAll {
  margin-right: 1px;
  border-radius: 4px 0px 0px 4px;
  padding: 5px 10px;
  /*width: 100%;*/
}

.el-button-group > .el-button:first-child:last-child {
  border-radius: 0px 4px 4px 0px;
  width: 100%;
}

.el-button-group > .el-button:first-child {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.createDropdown {
  color: #fff;
  background-color: #409eff !important;
  border-color: #409eff;
  padding: 5px 10px;
}

.createDropdown:hover,
.createDropdown:focus {
  color: #fff;
}

.gallery-action__item .el-button {
  padding: 4px 10px;
}

.gallery-createFolder {
  width: 100%;
  text-align: left;
  margin: 0px !important;
  padding: 5px 10px !important;
}

.media-list-header-container #action-container {
  display: inline-block;
  vertical-align: top;
}

.createNewMedia {
  display: inline-block;
}

@media (max-width: 1025px) {
  /*.el-button-group {*/
  /*     width: unset;*/
  /*}*/

  .gallery-createFolder {
    font-size: 14px !important;
  }

  #btn_SelectAll {
    width: 100%;
    border-radius: unset !important;
    margin-bottom: 2px;
    border-right-color: unset;
    border-color: unset;
  }

  #btn_UnselectAll {
    border-radius: unset !important;
    width: 100%;
    margin: 0px 0px 2px 0px;
    border-left-color: unset;
    border-color: unset;
  }

  .media-list-header-container #action-container .gallery-action__item button {
    border-radius: unset !important;
    margin-bottom: 2px !important;
    border-color: unset;
  }

  .createNewMedia {
    display: block;
  }

  .media-list-header-container .createNewMedia button {
    border-radius: unset;
    border-color: unset;
    margin-bottom: 2px;
  }

  .media-list-header-container #action-container .gallery-select {
    width: 100%;
  }

  .media-list-header-container #action-container {
    display: block;
  }

  .media-list-header-container .download-selected {
    padding: 5px 10px;
    border-radius: unset;
    border-color: unset;
  }
}

@media (max-width: 769px) {
  .gallery-createFolder {
    font-size: 14px !important;
  }

  #btn_SelectAll {
    width: 100%;
    border-radius: unset !important;
    margin-bottom: 2px;
    border-right-color: unset;
    border-color: unset;
  }

  #btn_UnselectAll {
    border-radius: unset !important;
    width: 100%;
    margin: 0px 0px 2px 0px;
    border-left-color: unset;
    border-color: unset;
  }

  .media-list-header-container #action-container .gallery-action__item button {
    border-radius: unset !important;
    margin-bottom: 2px !important;
    border-color: unset;
  }

  .createNewMedia {
    display: block;
  }

  .media-list-header-container .createNewMedia button {
    border-radius: unset;
    border-color: unset;
    margin-bottom: 2px;
  }

  .media-list-header-container #action-container .gallery-select {
    width: 100%;
  }

  .media-list-header-container #action-container {
    display: block;
  }

  .media-list-header-container .download-selected {
    padding: 5px 10px;
    border-radius: unset;
    border-color: unset;
  }
}

@media (max-width: 450px) {
  .gallery-createFolder {
    font-size: 14px !important;
  }

  #btn_SelectAll {
    width: 100%;
    border-radius: unset !important;
    margin-bottom: 2px;
    border-right-color: unset;
    border-color: unset;
  }

  #btn_UnselectAll {
    border-radius: unset !important;
    width: 100%;
    margin: 0px 0px 2px 0px;
    border-left-color: unset;
    border-color: unset;
  }

  .media-list-header-container #action-container .gallery-action__item button {
    border-radius: unset !important;
    margin-bottom: 2px !important;
    border-color: unset;
  }

  .createNewMedia {
    display: block;
  }

  .media-list-header-container .createNewMedia button {
    border-radius: unset;
    border-color: unset;
    margin-bottom: 2px;
  }

  .media-list-header-container #action-container .gallery-select {
    width: 100%;
  }

  .media-list-header-container #action-container {
    display: block;
  }

  .media-list-header-container .download-selected {
    padding: 5px 10px;
    border-radius: unset;
    border-color: unset;
  }
}
</style>

<style>
@media (max-width: 1025px) {
  .media-list-header-container .gallery-action__item button span {
    width: auto;
    overflow: unset;
  }

  .media-list-header-container #action-container .el-button-group {
    /*width: 100%;*/
  }
}

@media (max-width: 769px) {
  .media-list-header-container .gallery-action__item button span {
    width: auto;
    overflow: unset;
  }

  .media-list-header-container #action-container .el-button-group {
    /*width: 100%;*/
  }
}

@media (max-width: 450px) {
  .media-list-header-container .gallery-action__item button span {
    width: auto;
    overflow: unset;
  }

  .media-list-header-container #action-container .el-button-group {
    /*width: 100%;*/
  }
}
</style>
